import * as yup from 'yup';

export const rulesSchema = yup.object().shape({
  rules: yup.object().shape({}),
  all_rules_chosen: yup.bool().required(),
  all_rules_switched: yup.bool().required(),
});
